var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"country-icon"},[(_vm.code)?_c('img',{style:({ height: _vm.size ? _vm.size : '15px', width: _vm.size ? _vm.size : '15px' }),attrs:{"alt":_vm.name,"src":require('@/assets/countries/' + _vm.code + '.png')}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c882f99","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/CountryIcon.vue
// module id = null
// module chunks = 